<div class="wrapper">
  <form [formGroup]="merchantInfo">

    <div class="main-block">
      <div class="left-side">

        <div class="bl">
          <div class="name">
            Company name En*:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" formControlName="companyNameEn">
          </div>
        </div>


        <div class="bl">
          <div class="name">
            Company name Hy*:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" formControlName="companyNameHy">
          </div>
        </div>

        <div class="bl">
          <div class="name">
            Company name Ru:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" formControlName="companyNameRu">
          </div>
        </div>

        <div class="bl">
          <div class="name">
            Address En*:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" formControlName="addressEn">
          </div>
        </div>

        <div class="bl">
          <div class="name">
            Address Hy*:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" formControlName="addressHy">
          </div>
        </div>

        <div class="bl">
          <div class="name">
            Legal company name*:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" formControlName="legalCompanyName">
          </div>
        </div>

        <div class="bl">
          <div class="name">
            Legal address*:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" formControlName="legalAddress">
          </div>
        </div>

        <div class="bl">
          <div class="name">
            Director:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" formControlName="director">
          </div>
        </div>

        <div class="bl">
          <div class="name">
            Phone:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" mask="000 000000" formControlName="phone">
          </div>
        </div>

        <!-- <div class="bl">
          <div class="name">
            SMS phone:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" prefix="+374" mask="00 00 00 00" formControlName="smsPhone">
          </div>
        </div> -->


        <div class="bl">
          <div class="name">
            Email:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" formControlName="email">
          </div>
        </div>

        <div class="bl">
          <div class="name">
            Website:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" formControlName="website">
          </div>
        </div>

        <div class="bl">
          <div class="name">
            Logo:&nbsp;
          </div>
          <div class="data">
            <!-- <input type="text" class="form-control" formControlName="logo"> -->
            <input type="file" accept="image/png, image/jpeg" (change)="uploadLogo($event)">
          </div>
        </div>

        <div class="bl">
          <div class="name">
            Bank serial number:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" formControlName="bankSerialNumber">
          </div>
        </div>

        <div class="bl">
          <div class="name">
            TIN:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" formControlName="tin">
          </div>
        </div>

        <div class="bl">
          <div class="name">
            Bank*:&nbsp;
          </div>
          <div class="data">
            <select #bank_value class="form-control" (change)="setBank(bank_value.value)">
              <option *ngIf="showBank">None</option>
              <option *ngFor="let bank of banks" [value]="bank.id">{{bank.title}}</option>

            </select>
          </div>
        </div>
        <div class="bl">
          <div class="name">
            Sphere of activity:&nbsp;
          </div>
          <div class="data">
            <input type="text" class="form-control" formControlName="sphereOfActivity">
          </div>
        </div>


      </div>

      <div class="right-side">
        <div class="main-info">

          <div class="bl">
            <div class="name">
              MCC*:&nbsp;
            </div>
            <div class="data">
              <input type="text" class="form-control" formControlName="mcc">
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Domain*:&nbsp;
            </div>
            <div class="data">
              <select #domain_value class="form-control" (change)="setDomain(domain_value.value)">
                <option *ngIf="showDomain">None</option>
                <option *ngFor="let domain of domains" [value]="domain.id">{{domain.title}}</option>
              </select>
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Merchant arca percent*:&nbsp;
            </div>
            <div class="data">
              <input type="text" mask="000" class="form-control" formControlName="merchantArcaPercent">
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Merchant local percent*:&nbsp;
            </div>
            <div class="data">
              <input type="text" maxlength="3" mask="000" class="form-control" formControlName="merchantLocalPercent">
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Merchant out percent*:&nbsp;
            </div>
            <div class="data">
              <input type="text" maxlength="2" mask="00" class="form-control" formControlName="merchantOutPercent">
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Bank internal tid:&nbsp;
            </div>
            <div class="data">
              <input type="text" class="form-control" formControlName="bankInternalTid">
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Bank internal mid:&nbsp;
            </div>
            <div class="data">
              <input type="text" class="form-control" formControlName="bankInternalMid">
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Fee type:&nbsp;
            </div>
            <div class="data">
              <select class="form-control" formControlName="feeType">
                <option selected value="1">Fixed</option>
                <option value="2">Percent</option>
              </select>
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Merchant type:&nbsp;
            </div>
            <div class="data">
              <select class="form-control" formControlName="merchantType">
                <option selected value="1">Merchant</option>
                <option value="2">MobileApp</option>
              </select>
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Status:&nbsp;
            </div>
            <div class="data">
              <select class="form-control" formControlName="status">
                <option selected value="0">In Process</option>
                <option value="1">Active</option>
                <option value="2">Closed</option>
              </select>
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Offline:&nbsp;
            </div>
            <div class="data">
              <input type="checkbox" formControlName="isOffline">
            </div>
          </div>

          <!-- <div class="bl">
            <div class="name">
              Merchant Group:&nbsp;
            </div>
            <div class="data">
              <input (change)="checkBanks()" [disabled]="groups.length == 0" [(ngModel)]="merchantGroup"
                [ngModelOptions]="{standalone: true}" type="checkbox">
            </div>
          </div> -->

        </div>

        <div class="arca-info" *ngIf="!merchantGroup">
          <div class="bl">
            <div class="name">
              Api:&nbsp;
            </div>
            <div class="data">
              <input type="text" class="form-control" formControlName="tidApi">
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Api password:&nbsp;
            </div>
            <div class="data">
              <input type="text" class="form-control" formControlName="bpcTidApiPassword">
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Binding:&nbsp;
            </div>
            <div class="data">
              <input type="text" class="form-control" formControlName="tidBinding">
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Binding password:&nbsp;
            </div>
            <div class="data">
              <input type="text" class="form-control" formControlName="bpcTidBindingPassword">
            </div>
          </div>
        </div>

        <div class="arca-info" *ngIf="merchantGroup">

          <div class="bl">
            <div class="name">
              Select group:&nbsp;
            </div>
            <div class="data">
              <select #group_value class="form-control" (change)="setGroup(group_value.value)">
                <option *ngIf="showGroups">None</option>
                <option *ngFor="let group of groups" [value]="group.id">{{group.merchantGroupName}}</option>
              </select>
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Api:&nbsp;
            </div>
            <div class="data">
              <input type="text" class="form-control disabled" formControlName="tidApi">
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Api password:&nbsp;
            </div>
            <div class="data">
              <input type="text" class="form-control disabled" formControlName="bpcTidApiPassword">
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Binding:&nbsp;
            </div>
            <div class="data">
              <input type="text" class="form-control disabled" formControlName="tidBinding">
            </div>
          </div>

          <div class="bl">
            <div class="name">
              Binding password:&nbsp;
            </div>
            <div class="data">
              <input type="text" class="form-control disabled" formControlName="bpcTidBindingPassword">
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="button">
      <button class="btn btn-secondary" (click)="cancelBtn()">Cancel</button>
      <button class="btn btn-success" (click)="setNewMerchant()">Add</button>
      <span>Or upload from excel</span>
      <label for="xlsx_inp" class="xlsx_cl">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
          <path style="fill:#507C5C;" d="M438.557,512H19.785c-8.216,0-14.876-6.66-14.876-14.876V256.916c0-8.216,6.66-14.876,14.876-14.876
	s14.876,6.66,14.876,14.876v225.332h389.021v-32.833c0-8.216,6.661-14.876,14.876-14.876c8.215,0,14.876,6.66,14.876,14.876v47.709
	C453.433,505.34,446.772,512,438.557,512z" />
          <g>
            <polygon style="fill:#CFF09E;" points="19.785,177.122 19.785,172.332 175.581,14.876 175.581,177.122 	" />
            <rect x="196.154" y="219.435" style="fill:#CFF09E;" width="296.061" height="163.65" />
          </g>
          <g>
            <path style="fill:#507C5C;" d="M492.215,204.559h-38.782V14.876C453.433,6.66,446.772,0,438.557,0H175.581
		c-0.183,0-0.363,0.021-0.546,0.027c-0.167,0.006-0.332,0.013-0.498,0.025c-0.643,0.046-1.282,0.118-1.909,0.245
		c-0.013,0.003-0.027,0.007-0.042,0.01c-0.617,0.126-1.22,0.305-1.815,0.509c-0.155,0.054-0.309,0.109-0.463,0.167
		c-0.585,0.222-1.159,0.469-1.711,0.762c-0.019,0.01-0.042,0.018-0.061,0.03c-0.568,0.305-1.108,0.66-1.635,1.04
		c-0.135,0.098-0.268,0.196-0.4,0.299c-0.522,0.402-1.028,0.827-1.497,1.3L9.21,161.868c-0.35,0.353-0.678,0.721-0.988,1.104
		c-0.207,0.254-0.388,0.521-0.576,0.784c-0.092,0.131-0.195,0.256-0.283,0.388c-0.214,0.324-0.405,0.66-0.592,0.998
		c-0.046,0.083-0.1,0.162-0.143,0.245c-0.183,0.347-0.342,0.701-0.495,1.056c-0.037,0.086-0.082,0.168-0.116,0.256
		c-0.14,0.341-0.256,0.689-0.369,1.038c-0.036,0.112-0.08,0.219-0.113,0.33c-0.095,0.321-0.17,0.646-0.242,0.971
		c-0.033,0.147-0.076,0.293-0.106,0.442c-0.058,0.3-0.095,0.604-0.134,0.907c-0.024,0.177-0.057,0.351-0.074,0.53
		c-0.028,0.303-0.034,0.607-0.045,0.912c-0.006,0.167-0.024,0.332-0.024,0.498v4.792c0,8.216,6.66,14.876,14.876,14.876h155.796
		c8.216,0,14.876-6.66,14.876-14.876V29.752h233.225v174.807H196.156c-8.216,0-14.876,6.66-14.876,14.876v163.644
		c0,8.216,6.66,14.876,14.876,14.876h296.059c8.215,0,14.876-6.66,14.876-14.876V219.435
		C507.091,211.219,500.43,204.559,492.215,204.559z M50.691,162.246L160.705,51.06v111.186H50.691z M477.339,368.203H211.032
		V234.311h266.308V368.203z" />
            <path style="fill:#507C5C;" d="M255.692,313.875l-16.073,27.302c-0.771,1.211-2.312,1.761-4.073,1.761
		c-4.734,0-11.45-3.743-11.45-8.476c0-0.991,0.33-1.981,0.992-3.082l19.046-29.393l-18.275-29.283
		c-0.771-1.211-1.101-2.312-1.101-3.413c0-4.623,6.275-8.148,11.12-8.148c2.422,0,4.073,0.881,5.174,2.862l14.642,25.54
		l14.641-25.54c1.101-1.981,2.754-2.862,5.175-2.862c4.844,0,11.12,3.523,11.12,8.148c0,1.101-0.332,2.202-1.101,3.413
		l-18.275,29.283l19.046,29.393c0.66,1.101,0.991,2.092,0.991,3.082c0,4.734-6.715,8.476-11.449,8.476
		c-1.761,0-3.413-0.55-4.073-1.761L255.692,313.875z" />
            <path style="fill:#507C5C;"
              d="M301.595,342.277c-3.744,0-7.487-1.761-7.487-5.284v-70.017c0-3.633,4.295-5.174,8.586-5.174
		c4.295,0,8.586,1.541,8.586,5.174v60.329h25.1c3.304,0,4.955,3.744,4.955,7.487c0,3.743-1.651,7.486-4.955,7.486h-34.786V342.277z" />
            <path style="fill:#507C5C;" d="M381.294,320.7c0-13.321-34.899-11.01-34.899-36.77c0-16.514,14.422-22.788,28.182-22.788
		c5.836,0,21.909,1.101,21.909,9.689c0,2.972-1.981,9.027-6.827,9.027c-3.963,0-6.055-4.183-15.083-4.183
		c-7.816,0-11.008,3.192-11.008,6.605c0,11.01,34.899,8.918,34.899,36.66c0,15.853-11.56,24.44-27.523,24.44
		c-14.421,0-26.531-7.045-26.531-14.312c0-3.744,3.304-9.248,7.486-9.248c5.175,0,8.476,8.148,18.715,8.148
		C375.68,327.967,381.294,325.985,381.294,320.7z" />
            <path style="fill:#507C5C;" d="M433.473,313.875l-16.073,27.302c-0.772,1.211-2.313,1.761-4.073,1.761
		c-4.735,0-11.449-3.743-11.449-8.476c0-0.991,0.33-1.981,0.991-3.082l19.046-29.393l-18.275-29.283
		c-0.771-1.211-1.101-2.312-1.101-3.413c0-4.623,6.276-8.148,11.12-8.148c2.422,0,4.073,0.881,5.175,2.862l14.642,25.54
		l14.642-25.54c1.099-1.981,2.752-2.862,5.174-2.862c4.845,0,11.12,3.523,11.12,8.148c0,1.101-0.33,2.202-1.101,3.413
		l-18.274,29.283l19.046,29.393c0.66,1.101,0.991,2.092,0.991,3.082c0,4.734-6.717,8.476-11.449,8.476
		c-1.763,0-3.414-0.55-4.073-1.761L433.473,313.875z" />
          </g>
        </svg>
        <input id="xlsx_inp" type="file" accept=".xlsx" (change)="readExcelFile($event)">
      </label>
      <!-- <button class="btn btn-success" (click)="setNewMerchant()">Add</button> -->
    </div>

  </form>

  <div class="loader" *ngIf="showLoader">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
